import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, Chapter, SectionHeading } from "./Reveal";

const FAQS = [
  ["What is Deyem?", "Deyem is a messaging platform designed to keep the important information inside conversations organised and easy to find."],
  ["Is messaging free?", "Yes. Standard messaging is free — direct messages, groups, photos, documents, voice notes, replies, reactions and search."],
  ["What is a Project?", "A Project is a Deyem conversation with additional organisation for things such as tasks, deadlines, approvals, measurements, photos and documents."],
  ["Who pays for a Project?", "Only the Project Owner requires a paid Project Owner subscription. Guests can participate without paying for that Project."],
  ["How much does Project Owner cost?", "£10/month with a 30-day free trial."],
  ["Do customers need to pay?", "No. Customers or guests invited into someone else's Project do not need a Project Owner subscription for that Project."],
  ["Is Deyem available on iPhone and Android?", "Yes — Deyem is available on iPhone and Android. Download it from the App Store or Google Play."],
  ["Does Deyem use AI?", "Deyem is designed around intelligent organisation and automation. We're building it to understand the useful information inside everyday conversations — and we'll only ship those capabilities when they genuinely work."],
];

export const FAQ = () => (
  <section id="faqs" className="bg-diem-paper py-28 sm:py-36" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-6 lg:px-8">
      <Chapter index="14" label="FAQs" />
      <div className="mt-8">
        <Reveal delay={0.1}>
          <SectionHeading>Questions, answered.</SectionHeading>
        </Reveal>
      </div>
      <Reveal delay={0.2}>
        <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
          {FAQS.map(([q, a], i) => (
            <AccordionItem
              key={q}
              value={`item-${i}`}
              className="rounded-2xl border border-diem-line bg-white px-6 data-[state=open]:border-diem-blue/40 transition-colors duration-300"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display text-lg font-medium tracking-tight text-diem-ink hover:no-underline py-5" data-testid={`faq-trigger-${i}`}>
                {q}
              </AccordionTrigger>
              <AccordionContent className="text-diem-slate leading-relaxed pb-5" data-testid={`faq-content-${i}`}>
                {a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
